import { OrderSchema, OrderStatusSchema } from "./Order";
import { TicketEventIdSchema } from "./TicketEvent";
import z from "zod";

export const TicketOrderStatusSchema = OrderStatusSchema;
export const TicketOrderIdSchema = z.string().brand("TicketOrderId");
export type TicketOrderId = z.infer<typeof TicketOrderIdSchema>;
export const TicketOrderSchema = z.object({
  id: TicketOrderIdSchema,
  order: OrderSchema,
  ticketEventTitle: z.string(),
  ticketEventId: TicketEventIdSchema,
  status: TicketOrderStatusSchema,
  customerName: z.string(),
  customerEmail: z.string(),
  ticketCount: z.number(),
  ticketCheckedInCount: z.number(),
});

export type TicketOrder = z.infer<typeof TicketOrderSchema>;
